import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { PDPAvailabilityNotificationsTranslationsProps } from "./types";
import React from "react";
import { PDPAvailabilityNotificationForm } from "./PDPAvailabilityNotificationForm";
import { PDPAvailabilityNotificationBanner } from "./PDPAvailabilityNotificationBanner";
import { formatOptionalStartingPrice } from "../../../../../domain/swarovski-optik/products/price/format-price";
import { PDPAvailabilityNotificationProductInfo } from "./PDPAvailabilityNotificationProductInfo";
import { PDPAvailabilityNotificationHeadlineElements } from "./shared/PDPAvailabilityNotificationHeadlineElements";
import { TextWithHeadlineAndButtonElements } from "./shared/TextWithHeadlineAndButtonElements";
import { SwarovskiModalWrapper } from "../../../../../components/_shared-components/ui-elements/SwarovskiModalWrapper";
import { css } from "@emotion/react";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { useGeneralTranslationsContext } from "../../../../../global/hooks/use-general-translations-context";
import { PDPAvailabilityNotificationState } from "./state";
import { T } from "../../../../../components/T";

export const PDPAvailabilityNotificationActive: ReactTFC<{
  locale: SwarovskiOptikLocaleFrontend;
  translations: PDPAvailabilityNotificationsTranslationsProps;
  privacyPolicyLink: string;
  screen: Extract<PDPAvailabilityNotificationState, { tag: "closed" | "sign-up" | "thank-you" }>;
  hideModalCallback: () => void;
}> = props => {
  const { translations, screen, hideModalCallback } = props;
  const generalTranslations = useGeneralTranslationsContext();

  return (
    <>
      <SwarovskiModalWrapper modalIsOpen={screen.tag !== "closed"} hideModalCallback={hideModalCallback}>
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <PDPAvailabilityNotificationHeadlineElements translations={props.translations} />

          {screen.tag === "sign-up" && (
            <>
              <PDPAvailabilityNotificationProductInfo
                variant={screen.variant}
                translations={translations}
                startingPrice={formatOptionalStartingPrice(
                  screen.variant.price,
                  generalTranslations("fromPriceLabel"),
                  props.locale,
                )}
              />

              <PDPAvailabilityNotificationForm
                onAvailabilitySubscription={screen.onAvailabilitySubscription}
                translations={props.translations}
                privacyPolicyLink={props.privacyPolicyLink}
              />
            </>
          )}

          {screen.tag === "thank-you" && (
            <TextWithHeadlineAndButtonElements
              headline={<T>{props.translations.thanksForSubscriptionLabel}</T>}
              paragraph={<T>{props.translations.youWillBeNotifiedLabel}</T>}
              buttonLabel={<T>{props.translations.closeModalBtnLabel}</T>}
              buttonAction={hideModalCallback}
            />
          )}
        </div>
      </SwarovskiModalWrapper>

      {(screen.tag === "closed" || screen.tag === "sign-up") && (
        <PDPAvailabilityNotificationBanner paragraph={screen.label} />
      )}
    </>
  );
};
